import React, { useCallback, useEffect, useState, useRef } from 'react';
import GetADemoGuide from '../GetADemoGuide';
import Link from 'next/link';
import router from 'next/router';
import { FormattedMessage, useIntl } from 'react-intl';
import { CommonSectionLayout } from 'src/components/POSWebsite/legacy';
const ScheduleYourFreeDemo = ({
  triggerSource = 'bottom',
  forEmailLanding = false,
  backgroundColor = '#ffffff',
  title = '',
}) => {
  const intl = useIntl();
  const onAfterSubmit = useCallback(() => {
    if (forEmailLanding) {
      router.replace('/get-a-demo/email-lead-confirm');
    } else {
      router.replace('/get-a-demo/confirm');
    }
  }, [forEmailLanding]);
  return (
    <CommonSectionLayout backgroundColor={backgroundColor || '#ffffff'} title={title || ''}>
      <GetADemoGuide
        triggerSource={triggerSource}
        forEmailLanding={forEmailLanding}
        showSkipNow={false}
        onAfterSubmit={onAfterSubmit}
        title={intl.formatMessage({ id: 'home.get-demo.form.title' })}
        subTitle={intl.formatMessage({ id: 'home.get-demo.form.subtitle' })}
      />
    </CommonSectionLayout>
  );
};

export default ScheduleYourFreeDemo;
